import * as React from 'react';

interface SkipToMainContentButtonProps {
  mainContentId: string;
  buttonText?: string;
}

export const SkipToMainContentButton: React.FC<SkipToMainContentButtonProps> = ({
  mainContentId,
  buttonText = 'Skip to main content'
}) => {
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    const mainContent = document.getElementById(mainContentId);
    if (mainContent) {
      mainContent.focus();
      mainContent.scrollIntoView();
    }
  };

  return (
    <a
      className="skip-to-main-content-button"
      href={`#${mainContentId}`}
      onClick={handleClick}
    >
      {buttonText}
    </a>
  );
};

export default SkipToMainContentButton;
